import { createSlice } from '@reduxjs/toolkit';

export interface ShareBalanceModalSliceState {
  isOpen: boolean;
}

const initialState: ShareBalanceModalSliceState = {
  isOpen: false,
};

const shareBalanceModalSlice = createSlice({
  name: 'shareBalanceModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { shareBalanceModalSlice };
